/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Resellers_No_Match_TitleInputs */

const id_staff_resellers_no_match_title = /** @type {(inputs: Staff_Resellers_No_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada reseller yang cocok`)
};

const en_staff_resellers_no_match_title = /** @type {(inputs: Staff_Resellers_No_Match_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No resellers match`)
};

/**
* | output |
* | --- |
* | "No resellers match" |
*
* @param {Staff_Resellers_No_Match_TitleInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_resellers_no_match_title = /** @type {((inputs?: Staff_Resellers_No_Match_TitleInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Resellers_No_Match_TitleInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_resellers_no_match_title(inputs)
	return id_staff_resellers_no_match_title(inputs)
});